// 门店，房屋相关的接口
import fetch from './tjFetch.js'
import abLS from '@/business/abLocalStorage'

const apiConfig = {
  getHouseList: `/api/pms/house/list.api`,
  getHouseListV2: `/api/pms/house/v2/list.api`,
  getHotelList: `/api/pms/hotel/list.api`,
  deleteHotel: `/api/pms/hotel/delete.api`,
  getRegions: `/api/pms/hotel/getRegions.api`,
  saveLocationInfo: `/api/pms/room/location.api`,
  deleteHouseType: `/api/pms/house/delete.api`,
  getGroupList: `/api/pms/group/list.api`,
  getGroupListV2: `/api/pms/group/v2/list.api`,
  deleteGroup: `/api/pms/group/delete.api`,
  addHotel: `/api/pms/hotel/add.api`,
  editHotel: `/api/pms/hotel/edit.api`,
  changeHotel: `/api/pms/hotel/changeHotel.api`,
  addGroup: `/api/pms/group/add.api`,
  detailGroup: `/api/pms/group/detail.api`,
  editGroup: `/api/pms/group/edit.api`,
  addHouseType: `/api/pms/house/add.api`,
  editHouseType: `/api/pms/house/edit.api`,
  // 编辑房型归属
  saveHouseOrder: `/api/pms/house/changeRoom.api`,
  // 业主列表
  getOwnerList: `/api/pms/roomOwner/list.api`,
  // 删除业主
  deleteOwner: `/api/pms/roomOwner/delete.api`,
  // 禁用/启用业主
  enableOwner: `/api/pms/roomOwner/enable.api`,
  // 新增/编辑业主
  editOwner: `/api/pms/roomOwner/edit.api`
}

const api = {}

const getData = (fromData) => {
  const config = {
    headers: {
      'accessToken': abLS.getAccessToken() || ''
    }
  }
  const data = {
    data: fromData || {},
    ...config,
    withCredentials: true
  }
  return data
}
// 获取房型列表
api.getHouseList = function(fromData) {
  return fetch.post(apiConfig.getHouseList, getData(fromData))
}
// 获取房型列表
api.getHouseListV2 = function(fromData) {
  return fetch.post(apiConfig.getHouseListV2, getData(fromData))
}
// 获取门店列表
api.getHotelList = function(fromData) {
  return fetch.post(apiConfig.getHotelList, getData(fromData))
}
// 删除门店
api.deleteHotel = function(fromData) {
  return fetch.post(apiConfig.deleteHotel, getData(fromData))
}
// 获取省市区
api.getRegions = function(fromData) {
  return fetch.post(apiConfig.getRegions, getData(fromData))
}
// 完善房屋位置
api.saveLocationInfo = function(fromData) {
  return fetch.post(apiConfig.saveLocationInfo, getData(fromData))
}
// 删除房型
api.deleteHouseType = function(fromData) {
  return fetch.post(apiConfig.deleteHouseType, getData(fromData))
}
// 获取分组列表
api.getGroupList = function(fromData) {
  return fetch.post(apiConfig.getGroupList, getData(fromData))
}
// 获取分组列表
api.getGroupListV2 = function(fromData) {
  return fetch.post(apiConfig.getGroupListV2, getData(fromData))
}
// 删除分组
api.deleteGroup = function(fromData) {
  return fetch.post(apiConfig.deleteGroup, getData(fromData))
}
// 添加门店
api.addHotel = function(fromData) {
  return fetch.post(apiConfig.addHotel, getData(fromData))
}
// 编辑门店
api.editHotel = function(fromData) {
  return fetch.post(apiConfig.editHotel, getData(fromData))
}
// 切换门店
api.changeHotel = function (fromData) {
  return fetch.post(apiConfig.changeHotel, getData(fromData))
}
// 新建分组
api.addGroup = function(fromData) {
  return fetch.post(apiConfig.addGroup, getData(fromData))
}
// 分组详情
api.detailGroup = function(fromData) {
  return fetch.post(apiConfig.detailGroup, getData(fromData))
}
// 编辑分组
api.editGroup = function(fromData) {
  return fetch.post(apiConfig.editGroup, getData(fromData))
}
// 新增房型
api.addHouseType = function(fromData) {
  return fetch.post(apiConfig.addHouseType, getData(fromData))
}
// 编辑房型
api.editHouseType = function(fromData) {
  return fetch.post(apiConfig.editHouseType, getData(fromData))
}
// 编辑房型归属
api.saveHouseOrder = function(fromData) {
  return fetch.post(apiConfig.saveHouseOrder, getData(fromData))
}
// 业主列表
api.getOwnerList = function(fromData) {
  return fetch.post(apiConfig.getOwnerList, getData(fromData))
}
// 删除业主
api.deleteOwner = function(fromData) {
  return fetch.post(apiConfig.deleteOwner, getData(fromData))
}
// 禁用/启用业主
api.enableOwner = function(fromData) {
  return fetch.post(apiConfig.enableOwner, getData(fromData))
}
// 新增/编辑业主
api.editOwner = function(fromData) {
  return fetch.post(apiConfig.editOwner, getData(fromData))
}
export default api
